import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  FETCH_INVESTIGATORS_WORKLOAD,
  fetchInvestigatorWorkloadSuccess,
  fetchInvestigatorWorkloadFail
} from '../../redux/actions/cm/investigators';

import { fetchInvestigatorWorkload } from '../../services/cm/investigatorsWorkload';

function* getInvestigatorsWorkloadWorker({ dashboardFilter }) {
  try {
    const investigators = yield call(fetchInvestigatorWorkload, {
      dashboardFilter
    });
    yield put(fetchInvestigatorWorkloadSuccess(investigators));
  } catch (error) {
    console.log(error);
    yield put(fetchInvestigatorWorkloadFail());
  }
}

export function* watchGetInvestigatorsWorkloadWorker() {
  yield takeEvery(
    FETCH_INVESTIGATORS_WORKLOAD,
    function* ({ payload: dashboardFilter }) {
      yield fork(getInvestigatorsWorkloadWorker, { dashboardFilter });
    }
  );
}
